import React from 'react';
import { PublicFooter } from '/imports/ui/PublicFooter';
import { SignedOutPageStyled } from '/imports/ui/SignedOutPage';
import { Logo } from '/imports/ui/Logo';
import { termsHtml } from '/imports/ui/terms';

// Wraps SignedOutPageStyled and layers the extra
// rules the old `styled(SignedOutPageStyled)` block added, via Tailwind
// descendant variants. `!` beats the base component's unlayered rules.
const termsExtraClasses = '[&_.wrapper]:w-[55rem]! [&_.wrapper]:max-w-[90%]! [&_.logo_img]:mt-8';

export const TermsPageStyled = (props: React.ComponentProps<typeof SignedOutPageStyled>) => (
  <SignedOutPageStyled
    {...props}
    className={`${props.className ? `${props.className} ` : ''}${termsExtraClasses}`}
  />
);

export const TermsPage = () => {
  return (
    <TermsPageStyled className="page">
      <div className="wrapper">
        <div><Logo size={3} /></div>
        <div dangerouslySetInnerHTML={{__html: termsHtml}} />
      </div>
      <PublicFooter />
    </TermsPageStyled>
  );
};
